import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=7d62e605&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=7d62e605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62e605",
  null
  
)

export default component.exports